import { useMemo, useQuery } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { object } from 'common/helpers'

import type { ProductCardDetailedWideProps } from 'components/_new/productCard/ProductCardDetailedWide/ProductCardDetailedWide'

import query from './discountCode.graphql'


const useFreeProduct = (couponCode: string) => {
  const { gender, plan } = useConnect({
    gender: 'models.me.gender',
    plan: 'models.subscription.currPlan.name',
  })

  const options = useMemo(() => ({
    name: 'discountCodeFreeProduct',
    variables: {
      code: couponCode,
      gender,
      plan,
    },
    modifyResult: (data) => {
      const freeProduct = object.get(data, 'discountCode.code.freeProduct')

      if (!freeProduct) {
        return null
      }

      // we don't need url here
      const { url, ratings, ...productData } = freeProduct

      productData.rating = ratings.avgRate

      return productData
    },
    cache: true,
    skip: !couponCode,
  }), [ couponCode, gender, plan ])

  return useQuery<ProductCardDetailedWideProps['data']>(query, options)
}


export default useFreeProduct
